export default "__VITE_ASSET__Bm$R9Nt___"